document.addEventListener("DOMContentLoaded",function(){
    init();
});

const init = () => {
    initiateTbhSlider();
    initVideoModals();
};

/*
    Slider
*/
const initiateTbhSlider = () => {
    var flickitySliderEl = document.querySelector('.tbh-slider--three-col');
    if(flickitySliderEl) {
        var flktyThreeColSlider = new Flickity( flickitySliderEl, {
            /*
                Options
            */
            cellAlign: 'center',
            groupCells: true,
        });
    }

};

/*
    Video Modals
*/
const handleModalKeydown = evt => {
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) {
        isEscape = (evt.key === "Escape" || evt.key === "Esc");
    } else {
        isEscape = (evt.keyCode === 27);
    }

    if (isEscape) {
        closeVideoModal();
    }
};

const closeVideoModal = () => {
    document.querySelector('body').classList.remove('overflow-hidden');
    document.querySelector('.tbh-slide__video-modal--active').classList.remove('tbh-slide__video-modal--active');
    document.querySelector('.tbh-slide__video-play-button--active').setAttribute('aria-expanded', false);
    document.querySelector('.tbh-slide__video-play-button--active').classList.remove('tbh-slide__video-play-button--active');
    document.removeEventListener('keydown', handleModalKeydown);
};



const initVideoModals = () => {
    const videoPlayBtns = document.querySelectorAll('.tbh-slide__video-play-button');
    const videoModalCloseBtns = document.querySelectorAll('.tbh-slide__video-modal__close');

    if(videoPlayBtns) {

        videoPlayBtns.forEach((btn) => {
            btn.addEventListener('click', e => {
                e.preventDefault();

                const btnID = btn.id;
                const btnNumber = btnID.slice(btn.id.indexOf('--') + 2);
                const videoModal = document.getElementById(`tbh-slide__video-modal--${btnNumber}`);

                if(videoModal) {
                    /*
                        Open this Modal
                    */
                    videoModal.classList.add('tbh-slide__video-modal--active');
                    btn.classList.add('tbh-slide__video-play-button--active');
                    btn.setAttribute('aria-expanded', true);
                    document.addEventListener('keydown', handleModalKeydown);

                    document.querySelector('body').classList.add('overflow-hidden');


                    const videoModalBG = videoModal.querySelector('.tbh-slide__video-modal__inner');

                    if(videoModalBG) {
                        videoModalBG.addEventListener('click', () => {
                            closeVideoModal();
                        });
                    }
                }
            });
        });

        videoModalCloseBtns.forEach((btn) => {
            btn.addEventListener('click', e => {
                e.preventDefault();
                closeVideoModal();
            });

        });

    }
};



